import store from '@/store/index';
const tenantCode = store.getters.currentTenant.tenantCode;
export default {
    'searchList': {
        'searchTxt': [
            {
                'name': '对账单编号',
                'value': 'dealingsBillNo',
                'type': 'input',
                'unfold': true,
                'span': 3
            },
            {
                'name': '截止期间',
                'value': 'endAccountCycle',
                'type': 'time',
                'timeType': 'month',
                'format': 'yyyy-MM',
                'placeholder': '截止期间',
                'unfold': true,
                'span': 3
            },
            {
                'name': '对账单状态',
                'value': 'dealingsBillStatuses',
                'type': 'select',
                'unfold': true,
                'span': 4,
                // 'data': '10',
                'optionNum': 'SYS_DEALINGS_BILL_STATUS',
                'multiple': true
            },
            {
                'name': '对账结果',
                'value': 'dealingsAccountResult',
                'type': 'select',
                'unfold': true,
                'span': 3,
                // 'data': '10',
                'optionNum': 'SYS_DEALINGS_ACCOUNT_RESULT',
                'multiple': false
            },
            // {
            //     'name': '对账模式',
            //     'value': 'accountMode',
            //     'type': 'select',
            //     'unfold': true,
            //     'span': 3,
            //     // 'data': '10',
            //     'optionNum': 'BMS_ACCOUNT_PATTERN',
            //     'multiple': false
            // },
            {
                'name': '会计主体',
                'value': 'accountName',
                'advanceLabel': '会计主体弹出框',
                'type': 'advance',
                'span': 4,
                'advanceConfig': [
                    { 'prop': 'operatingUnitName', 'value': '会计主体名称' },
                    { 'prop': 'operatingUnitId', 'value': '会计主体编码' }
                ],
                'tableConfig': [
                    { 'prop': 'operatingUnitName', 'value': '会计主体名称' },
                    { 'prop': 'operatingUnitId', 'value': '会计主体编码' }
                ],
                'cbParams': ['operatingUnitName#accountName', 'operatingUnitId#ledgerId'],
                'advanceUrl': '/common/anntoFeeHead/efOrganRelation/page?enabledFlag=1&tenantCode=' + tenantCode,
                'prefix': 'api-bcp-web',
                'unfold': true
            }],
        'unfoldState': false,
        'advancedBtn': true
    },
    'table':
    {
        'selectBtn': false,
        'height': 400,
        'columns': [
            {
                'label': '对账单编号',
                'prop': 'dealingsBillNo'
            },
            {
                'label': '截止期间',
                'prop': 'endAccountCycle',
                'width': '60px'
            },
            {
                'label': '会计主体',
                'prop': 'ledgerName',
                'width': '180px'
            },
            {
                'label': '供应商编码',
                'prop': 'supCode',
                'width': '80px'
            },
            {
                'label': '供应商',
                'prop': 'supName',
                'width': '180px'
            },
            {
                'label': '对账单状态',
                'prop': 'dealingsBillStatus',
                'optionNum': 'SYS_DEALINGS_BILL_STATUS',
                'type': 'select',
                'width': '80px'
            },
            {
                'label': '对账结果',
                'prop': 'dealingsAccountResult',
                'optionNum': 'SYS_DEALINGS_ACCOUNT_RESULT',
                'type': 'select',
                'width': '80px'
            },
            {
                'label': '对账模式',
                'prop': 'accountMode',
                'optionNum': 'BMS_ACCOUNT_PATTERN',
                'type': 'select',
                'width': '60px'
            },
            {
                'label': '回复说明',
                'prop': 'replyStatement'
            },
            {
                'label': '对账日期',
                'prop': 'accountDate'
            }
        ],
        'leftOperation': false
    },
    'page': {
        'layout': 'total, sizes, prev, pager, next, jumper',
        'pageSize': 10
    },
    'searchTotalTitle': []
};
